import React from 'react';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';
import { addFrontendBreadcrumb, captureFrontendException } from './sentry';

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
};

export class FrontendErrorBoundary extends React.Component<Props, State> {
  state: State = {
    hasError: false,
  };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    addFrontendBreadcrumb('react_error_boundary_triggered', {
      componentStack: errorInfo.componentStack,
    });

    captureFrontendException(error, {
      react_error_boundary: {
        componentStack: errorInfo.componentStack,
      },
    });
  }

  private handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 3,
          bgcolor: '#f8fafc',
        }}
      >
        <Stack spacing={2} sx={{ maxWidth: 520, width: '100%' }}>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            Възникна грешка в приложението
          </Typography>
          <Alert severity="error">
            Грешката е отчетена. Презареди страницата и ако проблемът се повтори, провери в Sentry за детайлите.
          </Alert>
          <Button variant="contained" onClick={this.handleReload}>
            Презареди
          </Button>
        </Stack>
      </Box>
    );
  }
}
